<button ansynButton (click)="onNewTask()">{{'New Task' | translate}}</button>
